import { ExpandCircleDown } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Grid,
  Link,
} from "@mui/material";

export default function HelpSection() {
  return (
    <Grid container mt={2} pt={3}>
      <Grid item xs={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandCircleDown sx={{ color: "comp3.main" }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography fontSize={20} fontWeight={700}>
              Help
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              fontSize: "18px",
              lineHeight: "30px",
              fontFamily: "Lato Regular",
              bgcolor: "comp3.light",
            }}
          >
            <Typography>
              For assistance in using this electronic Professional Portfolio
              tool, contact Care Solutions, Inc. at (800)227-3410 during
              business hours (8:30 AM to 5:30 PM EST Monday-Friday) or via email
              to{" "}
              <Link href="mailto:support@yourcdaportfolio.org" type="email">
                support@yourcdaportfolio.org
              </Link>
            </Typography>
            <Typography mt={3}>
              For questions about the CDA credential and Professional Portfolio
              requirements, consult your{" "}
              <span style={{ color: "#CC581F", fontStyle: "italic" }}>
                CDA Competency Standards
              </span>{" "}
              book, your training instructor, or your child care technical
              assistance provider.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}
